import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListDivisions } from "../../../components/Admin/Divisions";
import { useLanguage } from "../../../contexts";
import "./Divisions.scss";

export function Divisions() {
  const { translations } = useLanguage();
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: "Divisiones activas",
      render: () => (
        <Tab.Pane attached={false}>
          <ListDivisions divisionsActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Divisiones inactivas",
      render: () => (
        <Tab.Pane attached={false}>
          <ListDivisions divisionsActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="divisions-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="divisions-page-header-wrapper">
        <div className="divisions-page-header">
          <span className="divisions-page-title">{translations.divisions}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
